//记得在 src\components\lang\zhLoad.js 里面添加对象
const byCoupon = {
  exchangeNo: '兑换ID',
  exchangeTime: '兑换时间',
  exchangePoints: '兑换积分',
  userName: '兑换人',
  areaName: '大区',
  cityName: '城市',
  customerName: '经销商',
  msg: {}
};
export default byCoupon



// WEBPACK FOOTER //
// ./src/page/pointsManagement/byCoupon/lang/byCoupon.zh.js